import CartsApi from '@/services/shop/CartsApiV2'
import type {
  CartInterface,
  CartItemInterface,
  CartTaxInterface,
} from '@/models/shop/CartV2.types'
import type { PackType } from '@/constants/packs'

export class CartTaxDTO implements CartTaxInterface {
  tax_id = ''
  invoice_label = ''
  rate = ''
  amount = ''
  taxable_amount = ''
}

export class CartItemDTO implements CartItemInterface {
  id = ''
  cart_id = ''
  arena_variant_id = ''
  arena_variant_name = ''
  arena_variant_image = ''
  arena_variant_sku = ''
  arena_variant_attributes = {}
  arena_variant_track_stock = false
  arena_variant_pack_type: PackType = null
  arena_promotion_id = ''
  arena_promotion_name = ''
  promotion_instance = 0
  promotion_discount_amount = ''
  category_code = ''
  arena_variant_price = ''
  arena_variant_price_discounted = ''
  quantity = 0
  total_net_price = ''
  total_gross_price = ''
  taxes: CartTaxInterface[] = []
  created_at = ''
  updated_at = ''
}

export class CartDTO implements CartInterface {
  id = ''
  arena_id = 0
  seller_user_id = 0
  buyer_user_id = 0
  currency_code = ''
  currency_symbol = ''
  coins_per_currency = 0
  total_net_amount = ''
  total_gross_amount = ''
  total_gross_amount_undiscounted = ''
  taxes: CartTaxInterface[] = []
  manual_discount_amount = ''
  coins_sold = 0
  coins_given = 0
  created_at = ''
  updated_at = ''
  items: CartItemInterface[] = []
}

export default class Cart extends CartDTO {
  static api = CartsApi

  constructor(DTO: CartDTO) {
    super()
    Object.assign(this, DTO)
  }
}
